import styles from "./Subpage.module.css";
import { Hero, HeroPanel } from "components/organisms";
import {
  SubpageHeader,
  PictureOrVideo,
  ContentContainer,
  Page,
} from "components/atoms";
import _ from "lodash";
import { FigCaption } from "components/molecules";
import { getAssetPath, useDeviceClassification } from "utils";
import { FC } from "react";
import { SimplifiedBannerDesktop } from "./components/SimplifiedBannerDesktop";
import { SimplifiedBannerMobile } from "./components/SimplifiedBannerMobile";
import { StandardHeroMobile } from "./components/StandardHeroMobile";

type THeaderProps = {
  DisplaySimplifiedBannerDesktop: boolean;
  DisplaySimplifiedBannerMobile: boolean;
  HeroSectionTitle: string;
  HeroSectionSuperscript: string;
  HeroSectionBlockOverlayColor: any;
  HeroSectionBlockOverlayColumn: number;
  HeroSectionVideo: any;
  HeroSectionVideoLoop: boolean;
  HeroSectionVideoAutoplay: boolean;
  heroPanels: any;
  HeroSectionImageMobile: any;
  HeroSectionVideoMobile: any;
  ContentOrientation: string;
  ShowQuickFactsSidebar: boolean;
}

export const Header: FC<THeaderProps> = ({
  DisplaySimplifiedBannerDesktop,
  DisplaySimplifiedBannerMobile,
  HeroSectionTitle,
  HeroSectionSuperscript,
  HeroSectionBlockOverlayColor,
  HeroSectionBlockOverlayColumn,
  HeroSectionVideo,
  HeroSectionVideoLoop,
  HeroSectionVideoAutoplay,
  heroPanels,
  HeroSectionImageMobile,
  HeroSectionVideoMobile,
  ShowQuickFactsSidebar
}: any) => {
  const { isDesktop, width } = useDeviceClassification();

  const _heroPanels = heroPanels?.length > 1 ? [...heroPanels, ...heroPanels, ...heroPanels] : heroPanels;

  /* Resource's for Desktop and Mobile Respectively */
  const mobileSrc = HeroSectionVideoMobile?.MediaUrl || HeroSectionImageMobile?.Src || heroPanels[0]?.MediaUrl || heroPanels[0]?.Src;
  const mobileAlt = HeroSectionVideoMobile?.ThumbnailImage?.Alt || HeroSectionImageMobile?.Alt || heroPanels[0]?.ThumbnailImage?.Alt || heroPanels[0]?.Alt;

  return (
    <div id="HeroContainer" style={{ background: 'white' }}>
      {isDesktop && DisplaySimplifiedBannerDesktop ?
        <SimplifiedBannerDesktop
          ShowQuickFactsSidebar={ShowQuickFactsSidebar}
          HeroSectionTitle={HeroSectionTitle}
          HeroSectionSuperscript={HeroSectionSuperscript}
        />
        :
        <>
          {
            !isDesktop && DisplaySimplifiedBannerMobile ?
              <SimplifiedBannerMobile
                HeroSectionTitle={HeroSectionTitle}
                HeroSectionSuperscript={HeroSectionSuperscript}
              />
              :
              <ContentContainer
                className="forHero"
              >
                <Page contentOrientation="flex-end" forHero>
                  {!isDesktop ? (
                    <div className={styles.mobileHeroBlockWrapper}>
                      <div className={styles.mobileHeroContent}>
                        <FigCaption mobile Alt={mobileAlt} />

                        <SubpageHeader
                          color={HeroSectionBlockOverlayColor?.Value}
                          columnWidth={HeroSectionBlockOverlayColumn || 5}
                        >
                          <h1>
                            {HeroSectionSuperscript && (
                              <span dangerouslySetInnerHTML={{ __html: HeroSectionSuperscript }}></span>
                            )}
                            {HeroSectionTitle && <div style={{ marginTop: '15px' }} dangerouslySetInnerHTML={{ __html: HeroSectionTitle }}></div>}
                          </h1>
                        </SubpageHeader>
                      </div>
                    </div>
                  ) : (
                    <>
                      <SubpageHeader
                        color={HeroSectionBlockOverlayColor?.Value}
                        columnWidth={HeroSectionBlockOverlayColumn || 5}
                      >
                        <h1>
                          {HeroSectionSuperscript && (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: HeroSectionSuperscript,
                              }}
                            />
                          )}

                          <em dangerouslySetInnerHTML={{ __html: HeroSectionTitle }} />
                        </h1>
                      </SubpageHeader>
                    </>
                  )}

                  {isDesktop &&
                    <Hero type="shuffle" isDesktop={isDesktop} width={width}>

                      {Boolean(_heroPanels?.length) && _heroPanels?.map(({ Alt = "", Src, MediaUrl, ThumbnailImage }, i) => {
                        return (
                          <HeroPanel
                            className="shuffle"
                            active={i === 0 ? true : false}
                            key={`hero-${i}`}
                            index={i}
                          >
                            <figure style={{
                              background: `url(${getAssetPath(MediaUrl || Src)})`,
                              backgroundSize: 'cover'
                            }}>
                              {Alt && !HeroSectionVideo?.MediaUrl && (
                                <FigCaption Alt={Alt} />
                              )}
                              <PictureOrVideo
                                src={MediaUrl || Src}
                                alt={ThumbnailImage?.Alt || Alt}
                                autoPlay={HeroSectionVideoAutoplay}
                                loop={HeroSectionVideoLoop}
                              />
                            </figure>
                          </HeroPanel>
                        );
                      })}
                    </Hero>
                  }
                  {
                    !isDesktop &&
                    <StandardHeroMobile
                      isDesktop={isDesktop}
                      width={width}
                      mobileSrc={mobileSrc}
                      mobileAlt={mobileAlt}
                      HeroSectionVideoAutoplay={HeroSectionVideoAutoplay}
                      HeroSectionVideoLoop={HeroSectionVideoLoop}
                    />
                  }
                </Page>
              </ContentContainer>
          }
        </>
      }
    </div>

  );
};
